import {makeStyles} from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  contentContainer: {
    color: theme.palette.primary.contrastText,
    width: '100%',
    height: '100%',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: '0 52px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px'
    }
  }
}))

interface ContentProps {
  className?: string
  style?: React.CSSProperties
  children?: React.ReactNode
}

const Content: React.FC<ContentProps> = ({children, className, ...props}) => {
  const classes = useStyles()
  return (
    <div className={clsx(classes.contentContainer, className)} {...props}>
      {children}
    </div>
  )
}

export default Content
